import React from "react";

function NotFoundRoute() {
  return (
    <div className="container">
      <div className="row">
        <div className="col d-flex justify-content-center">
          <h1 className="h1">Nothing was found.</h1>
        </div>
      </div>
    </div>
  );
}

export default NotFoundRoute;
